import React, { useMemo } from 'react'
import { motion } from 'motion/react'

import { EffectBackgroundProps } from '../types'

export const AuroraEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#6366f1', '#8b5cf6', '#ec4899'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100

  const color0 = effectColors[0] || '#6366f1'
  const color1 = effectColors[1] || '#8b5cf6'
  const color2 = effectColors[2] || '#ec4899'

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        overflow: 'hidden',
        backgroundColor: effectBackgroundColor,
      }}
    >
      {/* Base radial gradient */}
      <motion.div
        style={{
          position: 'absolute',
          inset: 0,
          background: `radial-gradient(ellipse at 50% 50%, ${color0}44, ${color1}22, transparent)`,
          opacity: opacityValue,
        }}
      />

      {/* First rotating gradient layer */}
      <motion.div
        style={{
          position: 'absolute',
          width: '200%',
          height: '200%',
          left: '-50%',
          top: '-50%',
          background: `linear-gradient(45deg, ${color0}66, ${color1}66, ${color2}66, transparent)`,
          opacity: opacityValue,
        }}
        animate={{
          rotate: [0, 360],
        }}
        transition={{
          duration: 20 * (100 / Math.max(effectSpeed, 1)),
          repeat: Infinity,
          ease: 'linear',
        }}
      />

      {/* Second rotating gradient layer (counter-clockwise) */}
      <motion.div
        style={{
          position: 'absolute',
          width: '200%',
          height: '200%',
          left: '-50%',
          top: '-50%',
          background: `linear-gradient(-45deg, ${color1}66, ${color2}66, ${color0}66, transparent)`,
          opacity: opacityValue,
        }}
        animate={{
          rotate: [360, 0],
        }}
        transition={{
          duration: 15 * (100 / Math.max(effectSpeed, 1)),
          repeat: Infinity,
          ease: 'linear',
        }}
      />
    </div>
  )
})
AuroraEffect.displayName = 'AuroraEffect'
